import { createContext, useContext, useState, type ReactNode } from 'react'
import { STORAGE_KEYS } from '@/constants'

interface LayoutContextValue {
  isCollapsed: boolean
  isMobileOpen: boolean
  toggleCollapsed: () => void
  toggleMobileOpen: () => void
  closeMobile: () => void
}

const LayoutContext = createContext<LayoutContextValue | undefined>(undefined)

export function LayoutProvider({ children }: { children: ReactNode }) {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(
    () => localStorage.getItem(STORAGE_KEYS.SIDEBAR_COLLAPSED) === 'true'
  )
  const [isMobileOpen, setIsMobileOpen] = useState(false)

  function toggleCollapsed(): void {
    setIsCollapsed((prev) => {
      const next = !prev
      localStorage.setItem(STORAGE_KEYS.SIDEBAR_COLLAPSED, String(next))
      return next
    })
  }

  function toggleMobileOpen(): void {
    setIsMobileOpen((prev) => !prev)
  }

  function closeMobile(): void {
    setIsMobileOpen(false)
  }

  return (
    <LayoutContext.Provider
      value={{ isCollapsed, isMobileOpen, toggleCollapsed, toggleMobileOpen, closeMobile }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export function useLayoutContext(): LayoutContextValue {
  const context = useContext(LayoutContext)
  if (!context) {
    throw new Error('useLayoutContext must be used within a LayoutProvider')
  }
  return context
}
